import type { RevenuePerMonthBreakdown } from '@weft/types';

export function getEmptyMonthlyRevenue(): RevenuePerMonthBreakdown {
  return {
    scheduledCharge: 0,
    revenue: 0,
    deferredRevenue: 0,
    unbilledRevenue: 0,
  };
}